<template>
    <div v-if="isVisible" class="new-year-snowfall" aria-hidden="true">
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
        <div class="snowflake">❄</div>
        <div class="snowflake">❅</div>
        <div class="snowflake">❆</div>
    </div>
</template>

<script>
export default {
    name: "NewYearSnowfall",
    data() {
        return {
            showSnow: true,
        };
    },
    computed: {
        isNewYearPeriod() {
            const now = new Date();
            const month = now.getMonth();
            const day = now.getDate();
            return (month === 11 && day === 31) || (month === 0 && day === 1);
        },
        isVisible() {
            return this.isNewYearPeriod && this.showSnow;
        },
    },
    mounted() {
        if (this.isNewYearPeriod) {
            setTimeout(() => {
                this.showSnow = false;
            }, 30000);
        }
    },
};
</script>

<style>
.new-year-snowfall {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 99999;
    overflow: hidden;
}

.new-year-snowfall .snowflake {
    position: absolute;
    top: -20px;
    color: #C4B5FF;
    font-size: 18px;
    animation: snowfall linear infinite;
    opacity: 1;
    user-select: none;
}

.new-year-snowfall .snowflake:nth-child(1) { left: 2%; animation-duration: 10s; animation-delay: 0s; font-size: 16px; }
.new-year-snowfall .snowflake:nth-child(2) { left: 6%; animation-duration: 14s; animation-delay: 1s; font-size: 20px; }
.new-year-snowfall .snowflake:nth-child(3) { left: 10%; animation-duration: 12s; animation-delay: 2s; font-size: 14px; }
.new-year-snowfall .snowflake:nth-child(4) { left: 14%; animation-duration: 16s; animation-delay: 0.5s; font-size: 18px; }
.new-year-snowfall .snowflake:nth-child(5) { left: 18%; animation-duration: 11s; animation-delay: 3s; font-size: 15px; }
.new-year-snowfall .snowflake:nth-child(6) { left: 22%; animation-duration: 13s; animation-delay: 1.5s; font-size: 22px; }
.new-year-snowfall .snowflake:nth-child(7) { left: 26%; animation-duration: 15s; animation-delay: 2.5s; font-size: 17px; }
.new-year-snowfall .snowflake:nth-child(8) { left: 30%; animation-duration: 10s; animation-delay: 0.3s; font-size: 13px; }
.new-year-snowfall .snowflake:nth-child(9) { left: 34%; animation-duration: 14s; animation-delay: 1.8s; font-size: 19px; }
.new-year-snowfall .snowflake:nth-child(10) { left: 38%; animation-duration: 12s; animation-delay: 0.8s; font-size: 16px; }
.new-year-snowfall .snowflake:nth-child(11) { left: 42%; animation-duration: 16s; animation-delay: 2.2s; font-size: 21px; }
.new-year-snowfall .snowflake:nth-child(12) { left: 46%; animation-duration: 11s; animation-delay: 0.1s; font-size: 14px; }
.new-year-snowfall .snowflake:nth-child(13) { left: 50%; animation-duration: 13s; animation-delay: 3.5s; font-size: 18px; }
.new-year-snowfall .snowflake:nth-child(14) { left: 54%; animation-duration: 15s; animation-delay: 1.2s; font-size: 15px; }
.new-year-snowfall .snowflake:nth-child(15) { left: 58%; animation-duration: 10s; animation-delay: 2.8s; font-size: 20px; }
.new-year-snowfall .snowflake:nth-child(16) { left: 62%; animation-duration: 14s; animation-delay: 0.6s; font-size: 17px; }
.new-year-snowfall .snowflake:nth-child(17) { left: 66%; animation-duration: 12s; animation-delay: 1.9s; font-size: 13px; }
.new-year-snowfall .snowflake:nth-child(18) { left: 70%; animation-duration: 16s; animation-delay: 3.2s; font-size: 22px; }
.new-year-snowfall .snowflake:nth-child(19) { left: 74%; animation-duration: 11s; animation-delay: 0.4s; font-size: 16px; }
.new-year-snowfall .snowflake:nth-child(20) { left: 78%; animation-duration: 13s; animation-delay: 2.1s; font-size: 19px; }
.new-year-snowfall .snowflake:nth-child(21) { left: 82%; animation-duration: 15s; animation-delay: 1.4s; font-size: 14px; }
.new-year-snowfall .snowflake:nth-child(22) { left: 86%; animation-duration: 10s; animation-delay: 2.6s; font-size: 21px; }
.new-year-snowfall .snowflake:nth-child(23) { left: 90%; animation-duration: 14s; animation-delay: 0.9s; font-size: 15px; }
.new-year-snowfall .snowflake:nth-child(24) { left: 93%; animation-duration: 12s; animation-delay: 3.8s; font-size: 18px; }
.new-year-snowfall .snowflake:nth-child(25) { left: 96%; animation-duration: 16s; animation-delay: 1.6s; font-size: 17px; }
.new-year-snowfall .snowflake:nth-child(26) { left: 4%; animation-duration: 11s; animation-delay: 4s; font-size: 20px; }
.new-year-snowfall .snowflake:nth-child(27) { left: 16%; animation-duration: 13s; animation-delay: 0.2s; font-size: 13px; }
.new-year-snowfall .snowflake:nth-child(28) { left: 36%; animation-duration: 15s; animation-delay: 2.4s; font-size: 22px; }
.new-year-snowfall .snowflake:nth-child(29) { left: 64%; animation-duration: 10s; animation-delay: 1.1s; font-size: 16px; }
.new-year-snowfall .snowflake:nth-child(30) { left: 84%; animation-duration: 14s; animation-delay: 3.3s; font-size: 19px; }

@keyframes snowfall {
    0% {
        transform: translateY(-20px) rotate(0deg) translateX(0);
        opacity: 1;
    }
    25% {
        transform: translateY(25vh) rotate(90deg) translateX(10px);
        opacity: 0.9;
    }
    50% {
        transform: translateY(50vh) rotate(180deg) translateX(-10px);
        opacity: 0.8;
    }
    75% {
        transform: translateY(75vh) rotate(270deg) translateX(10px);
        opacity: 0.7;
    }
    100% {
        transform: translateY(100vh) rotate(360deg) translateX(-10px);
        opacity: 0.5;
    }
}

/* Dark mode için kar taneleri */
.dark-mode .new-year-snowfall .snowflake {
    color: #D0C4FF;
}
</style>
